module.exports = __webpack_public_path__ + "img/high-bay_and_low-bay.391cd287.jpg";